import { Action } from '@ngrx/store'

export enum ActionLoadingTypes {
    ShowLoading = '@LOADING/SHOW',
    ShowLoadingProgress = '@LOADING/SHOW_PROGRESS',
    HiddenLoading = '@LOADING/HIDE',
}

export const ShowLoading = () => {
    return <Action>{ type: ActionLoadingTypes.ShowLoading}
}

export const ShowLoadingProgress = () => {
    return <Action>{ type: ActionLoadingTypes.ShowLoadingProgress}
}

export const HiddenLoading = () => {
    return <Action>{ type: ActionLoadingTypes.HiddenLoading }
}
